<template>
  <section class="mt-10">
    <div class="level">
      <div class="level-left">
      </div>
      <div class="level-right">
        <b-field class="file">
          <b-upload v-model="pjFiles" multiple @input="addPiecesJointe">
            <a class="button is-primary">
              <p class="is-size-14px has-text-weight-bold">
                {{$t('detailClient.ongletPJ.btnAjoutPJ')}}
              </p>
            </a>
          </b-upload>
          </b-field>
      </div>
    </div>
    <div class="columns is-12 is-multiline">
      <div class="column is-4 pointer"
        v-for="(pj, i) in listesPJ"
        :key="i"
        @click="ouvrirPJ(pj)">
        <div class="media media-align-center has-background-white">
          <figure class="media-left ma-10">
            <p class="image">
              <img class="picto-file-mail" :src="getImgPictoFile(pj.nom)">
            </p>
          </figure>
          <div class="media-content ma-10">
            <div class="content width-file-name">
              <p class="is-size-14px has-text-weight-bold has-text-gird-1 mb-0 truncate-file-name">
                {{pj.nom}}
              </p>
              <p class="is-size-7 has-text-default">
                {{formatDate(pj.creationTime)}} - {{bytesToSize(pj.size)}}
              </p>
            </div>
          </div>
          <div class="media-right">
                <b-icon custom-class="icon-color" icon="dots-vertical"></b-icon>
          </div>
        </div>
      </div>
      <div class="column ma-10 card-contact" v-if="!listesPJ.length">
          <div class="media media-align-center">
            <div class="media-content">
              <div class="content has-text-centered is-size-7">
                {{$t('detailClient.ongletPJ.aucunPJ')}}
              </div>
            </div>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { GetPJAsync } from '@/api/pieceJointes/index.js';
import { getImgPictoFile, bytesToSize } from '@/services/general/general';
import generePJ from '@/services/piecesJointes/genererPiecesJointes';
import { insertPieceJointe } from '@/services/piecesJointes/savePiecesJointes';
import gestionErreur from '@/services/general/gestionErreur';
import * as types from '@/store/modules/client-mutation-type';
import moment from 'moment';

const Client = createNamespacedHelpers('client');

export default {
  components: {
  },
  data: () => ({
    listesPJ: {},
    pjFiles: [],
  }),
  methods: {
    ...Client.mapMutations({
      addPJ: types.SET_PJ,
      videPJ: types.VIDER_PJ,
    }),
    async getPiecesJointes() {
      try {
        const pieceJointes = (await GetPJAsync(this.$route.params.id)).data;
        this.listesPJ = pieceJointes.filter(pj => pj.placeType !== 'Logo');
      } catch (error) {
        gestionErreur(`Erreur lors de la récupération des pièces jointes du client id: ${this.$route.params.id}`, error);
      }
    },
    getImgPictoFile(name) {
      const split = name.split('.');
      const type = split[split.length - 1];
      return getImgPictoFile(type)
    },
    bytesToSize(size) {
      return bytesToSize(size);
    },
    async addPiecesJointe() {
      const piecesJointes = await generePJ(this.pjFiles.map(file => {
        return {file, placeType: ''};
      }));
      this.addPJ(piecesJointes);
      this.pjFiles = [];
      const idClient = this.$route.params.id;
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await insertPieceJointe(piecesJointes, idClient, 'Client');
        this.videPJ();
        await this.getPiecesJointes();
        loadingComponent.close();
      } catch (error) {
        gestionErreur(`Erreur lors de l'ajout des pièces jointes du client id: ${this.$route.params.id}`, error);
        loadingComponent.close();
      }
    },
    formatDate(date) {
      return moment(date).format('LL');
    },
    ouvrirPJ(pj) {
      var a = document.createElement("a");
      a.href = pj.chemin;
      a.download = pj.nom;
      a.dataset["downloadurl"] = [ MimeType, a.href].join(":");
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
    },
  },
  mounted() {
    this.getPiecesJointes();
  }
};
</script>

<style>

</style>